module.exports = __webpack_public_path__ + "img/eeia-logo.9d2358cf.png";